module.exports = __webpack_public_path__ + "static/media/IMG_0648.cd3d03d8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/modra/IMG_0648.JPG
// module id = 92
// module chunks = 0